// @ts-nocheck
import React, { useEffect, useState } from "react";
import { Form, Input, Button, Spin, Select } from "antd";
import styles from "./index.module.scss";
const { Option } = Select;

const SourceForm = ({
  editConnection,
  sourceData,
  setSourceData,
  handleNext,
  setResetForms,
  resetForms,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [fileType, setFileType] = useState(null); // State to manage the file type

  const onFinish = (values) => {
    setLoading(true);
    setResetForms(false);
    setSourceData(values); // Set the source data
    handleNext(); // Move to the next step
    setLoading(false);
  };
  useEffect(() => {
    if (editConnection && Object.keys(editConnection).length > 0) {
      // Set all fields, including the connection name, when editing
      form.setFieldsValue({
        connectionName: editConnection?.connectionName,
        ...editConnection?.source,
      });
      setFileType(editConnection?.source.fileType); // Set fileType from sourceData
    } else if (sourceData) {
      form.setFieldsValue(sourceData);
      setFileType(sourceData.fileType); // Set fileType from sourceData
    } else {
      form.resetFields();
      setFileType(null); // Reset fileType to null if initialValues are empty
    }
  }, [form, sourceData, editConnection]);

  useEffect(() => {
    if (resetForms && editConnection == null) {
      form.resetFields();
      setFileType(null); // Reset fileType to null if initialValues are empty

      setResetForms(false); // Reset form state after reset
    }
  }, [resetForms, setResetForms, form]);

  return (
    <div>
      {loading && (
        <div className={styles.overlay}>
          <Spin size="large" />
        </div>
      )}
      <Form
        form={form}
        name="source"
        layout="vertical"
        initialValues={{ remember: true }}
        onFinish={onFinish}
      >
        <Form.Item
          label="Connection Name"
          name="connectionName"
          rules={[
            { required: true, message: "Please input your Connection Name!" },
          ]}
        >
          <Input
            disabled={editConnection && Object.keys(editConnection).length > 0} // Disable input if editConnection exists
            value={editConnection?.connectionName} // Set the value if in edit mode
          />
        </Form.Item>
        <Form.Item
          label="Host"
          name="host"
          rules={[{ required: true, message: "Please input the Host!" }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="User"
          name="user"
          rules={[{ required: true, message: "Please input the User!" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Password"
          name="password"
          rules={[{ required: true, message: "Please input the Password!" }]}
        >
          <Input.Password />
        </Form.Item>
        <Form.Item
          label="Source Directory"
          name="sourceDir"
          rules={[
            { required: true, message: "Please input the Source Directory!" },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Processed Directory"
          name="processedDir"
          rules={[
            {
              required: true,
              message: "Please input the Processed Directory!",
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="File Extension"
          name="fileType"
          rules={[{ required: true, message: "Please select a File Type!" }]}
        >
          <Select
            placeholder="Select a file type"
            onChange={(value) => {
              setFileType(value); // Update fileType state on selection
              form.setFieldsValue({ delimiter: undefined }); // Reset delimiter when changing file type
            }}
          >
            <Option value="csv">CSV</Option>
            <Option value="txt">Text</Option>
          </Select>
        </Form.Item>

        {fileType === "txt" && ( // Only show delimiter input if file type is Text
          <Form.Item
            label="Delimiter"
            name="delimiter"
            rules={[
              {
                validator: (_, value) => {
                  if (!value) {
                    return Promise.reject("Please input your Delimiter!");
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <Input placeholder="Enter delimiter (e.g., , or |)" />
          </Form.Item>
        )}

        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Button type="primary" htmlType="submit">
            Next
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default SourceForm;
